import { Render } from '@adobe-commerce/elsie/lib';
import { Provider } from './Provider';

export const render = new Render(<Provider />);
